import { Box, ColorOptions, ModalDialogNew, Spacer, Text } from '@jfs/ui-new'
import { useState } from 'react'
import { Dimensions, Linking } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'
import { SvgImage } from '../../comps/SvgImage'

import { Colors } from '../../util/util'
import { faqData } from './faqData'

const LinkText = (props) => {
  return (
    <Box testID="support" onPress={() => Linking.openURL(props.link)} underlayColor="TRANSPARENT">
      <Box position="relative" top={5}>
        <Text textAlign="center" color={'PRIMARY'} fontFamily={'JioType-Bold'} fontSize={14}>
          {props.text}
        </Text>
      </Box>
    </Box>
  )
}

const RenderSubItem = ({ item }: any) => {
  let children = item
  if (typeof children !== 'string') {
    const anchorStart = children?.text.indexOf('<a>')
    let anchorEnd = children?.text.indexOf('</a>')
    if (anchorEnd === -1) {
      anchorEnd = children?.text.length - 4
    }
    if (anchorStart >= 0) {
      const preText = children?.text.substring(0, anchorStart)
      const linkText = children?.text.substring(anchorStart + 3, anchorEnd)
      const postText = children?.text.substring(anchorEnd + 4)
      children = [preText, <LinkText text={linkText} link={children?.link} />, postText]
    } else {
      children = children?.text
    }
  }
  return (
    <Box align={'flex-start'}>
      <Text
        title={item}
        color={Colors.BLACK_14 as ColorOptions}
        fontFamily={'JioType-Medium'}
        fontSize={14}
        lineHeight={22}>
        {children}
      </Text>
    </Box>
  )
}

const RenderItem = ({ item, index, isMobile, selectedIndex }: any) => {
  const [showModal, setShowModal] = useState(false)
  const isSelected = selectedIndex === index

  const height = Dimensions.get('screen').height
  const renderSubItem = ({ item }: any) => {
    return <RenderSubItem item={item} isMobile={isMobile} />
  }

  const handlePress = () => {
    setShowModal(true)
  }

  // console.log('test item.subTitles', item.subTitles)
  return (
    <Box pv={12} bg={'WHITE'} borderBottomWidth={1} borderBottomColor={'#D9D9D9' as ColorOptions}>
      <Box
        flexDirection={'row'}
        underlayColor={'TRANSPARENT'}
        testID="faq-arrow"
        onPress={handlePress}
        justify={'space-between'}>
        <Box maxWidth={'90%'}>
          <Text
            title={item.title}
            color={Colors.BLACK as ColorOptions}
            fontSize={isMobile ? 14 : 16}
            fontFamily={isMobile && isSelected ? 'JioType-Bold' : 'JioType-Medium'}
          />
        </Box>
        <Box maxWidth={'10%'} alignItems="flex-end">
          <SvgImage imageName="FaqArrowRight" />
        </Box>
      </Box>
      <ModalDialogNew
        onBackPress={() => setShowModal(false)}
        animate={true}
        show={showModal}
        type="bottom"
        backgroundColor="TRANSPARENT">
        <Box borderTopLeftRadius={30} borderTopRightRadius={30} bg="WHITE" overflow={'hidden'} p={25}>
          <Spacer size={20} direction="vertical" />
          <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={20}>
            <Box width={'90%'}>
              <Text fontFamily="JioType-Black" fontSize={18} lineHeight={24}>
                {item.title}
              </Text>
            </Box>
            <Box testID="close-faq" onPress={() => setShowModal(false)} underlayColor={'TRANSPARENT'}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>

          <FlatList style={{ flexGrow: 1, maxHeight: height - 350 }} data={item.subTitles} renderItem={renderSubItem} />
        </Box>
      </ModalDialogNew>
    </Box>
  )
}

export const Accordion = ({ type }: { type: any }) => {
  const [selectedIndex, setSelectedIndex] = useState(-1)

  const renderItem = ({ item, index }: any) => {
    return (
      <RenderItem
        item={item}
        index={index}
        isMobile={true}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />
    )
  }

  return (
    <Box bg="WHITE">
      <Spacer size={12} />
      <Box w={'100%'}>
        <FlatList
          data={faqData[type]}
          renderItem={renderItem}
          style={{ borderRadius: 16 }}
          showsVerticalScrollIndicator={false}
          scrollEnabled={false}
        />
      </Box>
    </Box>
  )
}
